import { getCookie } from '@kizi/comparator-components';

export const constructOrderVariables = ({
  product,
  sessionId,
  builderData,
}) => {
  const isCBAPP = window.navigator.userAgent.includes('CBAPP') ? 'CBAPP' : getCookie('ref') ?? '';
  return {
    orderInput: {
      comparisonId: product?.comparisonId,
      sessionId,
      googleAnalyticsId: getCookie('_ga'),
      subscriptionId: parseInt(product?.id),
      supplierId: product?.provider.id,
      test: 0,
      email: 1,
      fields: {
        ...builderData,
        process: {
          ...(isCBAPP && {
            reference: 'CBAPP',
          }),
        }
      },
    },
  };
};
